import { render, staticRenderFns } from "./Cabecera.vue?vue&type=template&id=37946602&scoped=true&"
import script from "./Cabecera.vue?vue&type=script&lang=js&"
export * from "./Cabecera.vue?vue&type=script&lang=js&"
import style0 from "./Cabecera.vue?vue&type=style&index=0&id=37946602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37946602",
  null
  
)

export default component.exports